import "../../../PaymentsLanding/paymentsLanding.scss";
import "./paymentsLandingLoading.scss";
import { Flex, Skeleton, Tabs } from "antd";
import { IntegratedMetricsLoading } from "components/PaymentsLanding/PaymentsMetrics/MetricsLoading";
import { type PageLoadingProps, SpinLoading } from "../PageLoading";
import { VyneTable } from "@vyne-shared/components/vyneTable/VyneTable";

export const PaymentsLandingLoading = ({ children }: PageLoadingProps) => (
    <>
        <Skeleton.Input className="vyne-payments-landing-range-picker" />
        <Flex justify="center" gap="middle" className="vyne-payment-landing-metrics-wrapper vyne-metrics-loading">
            <IntegratedMetricsLoading />
        </Flex>
        <Tabs
            items={[
                {
                    key: "Loading-Tab-1",
                    label: <Skeleton.Input />,
                    children: <FakeTable>{children}</FakeTable>,
                },
                {
                    key: "Loading-Tab-2",
                    label: <Skeleton.Input />,
                    disabled: true,
                },
                {
                    key: "Loading-Tab-3",
                    label: <Skeleton.Input />,
                    disabled: true,
                },
            ]}
            className="vyne-payments-landing-tabs"
            animated={{ inkBar: false, tabPane: false }}
        />
    </>
);

const FakeHeader = () => (
    <div className="ant-skeleton ant-skeleton-element" style={{ color: "transparent" }}>
        <span className="ant-skeleton-input">Loading</span>
    </div>
);

const FakeTable = ({ children }: Readonly<React.PropsWithChildren>) => (
    <>
        <div className="vyne-tabs-content-header">
            <Skeleton.Input active={true} />
        </div>
        <div className="vyne-tabs-content">
            <VyneTable
                name="Page Loading Table"
                columns={fakeColumns}
                className="vyne-payments-landing-tabs"
                locale={{
                    emptyText: <SpinLoading>{children}</SpinLoading>,
                }}
            />
        </div>
    </>
);

const fakeColumns = [
    {
        title: <FakeHeader />,
        key: "Loading-Col-1",
    },
    {
        title: <FakeHeader />,
        key: "Loading-Col-2",
    },
    {
        title: <FakeHeader />,
        key: "Loading-Col-3",
    },
    {
        title: <FakeHeader />,
        key: "Loading-Col-4",
    },
    {
        title: <FakeHeader />,
        key: "Loading-Col-5",
    },
    {
        title: <FakeHeader />,
        key: "Loading-Col-6",
    },
];
